import { Component, Input, OnChanges, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { AdditionalInfo, Product } from '@/app/shared/interface/product.interface';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-product-details-tabs',
  templateUrl: './product-details-tabs.component.html',
  styleUrls: ['./product-details-tabs.component.scss']
})
export class ProductDetailsTabsComponent implements OnInit, OnChanges {

  @Input() product: Product;
  showMore: boolean[] = [];
  displayTag: any[] = [];
  documentTag: any;
  public active = '';

  constructor(@Inject(PLATFORM_ID) private platformId: Object){}

  ngOnInit() {}

  ngOnChanges() {
    if (this.product.documents && this.product.documents.length > 0) {
      this.documentTag = {
        display: true,
        name: "Hồ sơ sản phẩm",
        value: `
          <ol>
            ${this.product.documents
              .map(
                (document) => `
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      class="text-[var(--primary-color)]"
                      href="${document.fileUrl}"
                    >
                      ${document.fileName}
                    </a>
                  </li>
                `
              )
              .join('')}
          </ol>
        `
      }
    }
    if (this.documentTag) {
      this.displayTag = [...this.product.additionalInfo, this.documentTag]
    } else {
      this.displayTag = this.product.additionalInfo;
    }
    this.active = this.product.additionalInfo[0].name;
  }

  decodeHtml(html: string): string {
    if (isPlatformBrowser(this.platformId)) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = html;
      return textarea.value;
    }
    return html;
  }
}
